import * as yup from 'yup'

export const schemaFurniture = yup.object().shape({
  mobiliario: yup.object().shape({
    tipoMobiliario: yup.string().required('El tipo de mobiliario es obligatorio'),
    codigo: yup.string().required('El código es obligatorio'),
    descripcion: yup.string().required('La descripción es obligatorio'),
  }),
})

export const schemaMachineByPoint = yup.object().shape({
  codigo: yup.string().required('El codigo es obligatorio'),
})

export const schemaServiceByPoint = yup.object().shape({
  codigo: yup.string().required('El codigo es obligatorio'),
})

export const schemaOrderLaundry = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  tipoRecepcion: yup.string().required('El tipo de recepción es obligatorio'),
  puntoId: yup.string().required('El punto es obligatorio'),
  nroBoleta: yup.string().when('tipoRecepcion', {
    is: (valorCampoTipoRecepcion) => valorCampoTipoRecepcion === 'MANUAL',
    then: yup.string().required('El número de boleta es obligatorio'),
    otherwise: yup.string(),
  }),
  servicioId: yup.string().required('El servicio es obligatorio'),
  responsable: yup.string().required('El responsable es obligatorio'),
  huespedId: yup.string().when('responsable', {
    is: (valorCampoResponsable) => valorCampoResponsable !== 'COLABORADOR',
    then: yup.string().required('El colaborador es obligatorio'),
    otherwise: yup.string(),
  }),
  colaboradorId: yup.string().when('responsable', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'COLABORADOR',
    then: yup.string().required('El colaborador es obligatorio'),
    otherwise: yup.string(),
  }),
})

export const schemaOrderLaundryReception = yup.object().shape({
  lugarRecepcion: yup.string().required('El lugar es obligatorio'),
  fechaRecepcion: yup.string().required('La fecha es obligatorio'),
  fechaProgramada: yup.string().required('La fecha es obligatorio'),
  puntoId: yup.string().required('El punto es obligatorio'),
})
export const schemaOrderLaundryWash = yup.object().shape({
  lugarLavado: yup.string().required('El lugar es obligatorio'),
  puntoId: yup.string().when('lugarLavado', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'LAVADO EN SITE',
    then: yup.string().required('El punto es obligatorio'),
    otherwise: yup.string(),
  }),
  proveedorId: yup.string().when('lugarLavado', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'LAVADO EN PROVEEDOR',
    then: yup.string().required('El proveedor es obligatorio'),
    otherwise: yup.string(),
  }),
  fechaRealLavado: yup.string().when('lugarLavado', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'LAVADO EN SITE',
    then: yup.string().required('La fecha es obligatorio'),
    otherwise: yup.string(),
  }),
  fechaEntregaProveedor: yup.string().when('lugarLavado', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'LAVADO EN PROVEEDOR',
    then: yup.string().required('La fecha de entrega es obligatorio'),
    otherwise: yup.string(),
  }),
  fechaProgramadaProveedor: yup.string().when('lugarLavado', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'LAVADO EN PROVEEDOR',
    then: yup.string().required('La fecha programada es obligatorio'),
    otherwise: yup.string(),
  }),
})

export const schemaOrderLaundryReceptionTypeClothe = yup.object().shape({
  tipoRopa: yup.string().required('El tipo de ropa es obligatorio'),
  cantidad: yup.string().required('La cantidad es obligatorio'),
})

export const schemaOrderLaundryBatchObs = yup.object().shape({
  tipoObservacion: yup.string().required('El tipo de observación es obligatorio'),
})

export const schemaOrderLaundryReceptionTypeClotheOperation = yup.object().shape({
  tipoRopa: yup.string().required('El tipo de ropa es obligatorio'),
  cantidad: yup.string().required('La cantidad es obligatorio'),
  origen: yup.string().required('El origen es obligatorio'),
  peso: yup.string().required('El peso es obligatorio'),
  PisoId: yup.string().required('El piso es obligatorio'),
  ModuloId: yup.string().required('El módulo es obligatorio'),
})
export const schemaOrderLaundryOut = yup.object().shape({
  lugarSalida: yup.string().required('El lugar es obligatorio'),
  fechaSalida: yup.string().required('La fecha es obligatorio'),
})

export const schemaObservationByInspect = yup.object().shape({
  categoria: yup.string().required('La categoría es obligatorio'),
  codigoObservacion: yup.string().required('El código es obligatorio'),
  descripcionObservacion: yup.string().required('La descripción es obligatorio'),
  fechaDeteccion: yup.string().required('La fecha de detección es obligatorio'),
  fechaPlanificadaCierre: yup.string().required('La fecha planificada es obligatorio'),
})
export const schemaLaundryFilter = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  puntoId: yup.string().optional(),
  fechaIni: yup.string().optional(),
  fechaFin: yup.string().optional(),
})

export const schemaLaundryWashingTimeFilter = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().optional(),
  siteId: yup.string().optional(),
  campamentoId: yup.string().optional(),
  puntoId: yup.string().optional(),
  huespedId: yup.string().optional(),
  habitacionId: yup.string().optional(),
  contrataId: yup.string().optional(),
  estadoOrden: yup.string().optional(),
  fechaPeriodoInicio: yup.string().optional(),
  fechaPeriodoFin: yup.string().optional(),
})

export const schemaInspectionSearch = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  puntoId: yup.string().optional(),
  fechaRango: yup.array().length(2).required('El rango de fechas es obligatorio').of(yup.date()),
  tipoAdministracion: yup.string(),
})

export const reportOccupancySchema = yup.object().shape({
  CompaniaId: yup.string().required('Compañia es requerido'),
  ClienteId: yup.string().required('Cliente es requerido'),
  SiteId: yup.string().required('Site es requerido'),
  CampamentoId: yup.string().required('Campamento es requerido'),
  fechaInicio: yup.string().when('mesCompleto', {
    is: false,
    then: yup.string().typeError('Fecha Inicio es requerido').required('Fecha Inicio es requerido'),
    otherwise: yup.string().nullable().notRequired(),
  }),
  fechaFin: yup.string().when('mesCompleto', {
    is: false,
    then: yup.string().typeError('Fecha Fin es requerido').required('Fecha Fin es requerido'),
    otherwise: yup.string().nullable().notRequired(),
  }),
})

// --------------------valuation

export const reportValuationSchema = yup.object().shape({
  CompaniaId: yup.string().required('Compañia es requerido'),
  ClienteId: yup.string().required('Cliente es requerido'),
  SiteId: yup.string().required('Site es requerido'),
  CampamentoId: yup.string().required('Campamento es requerido'),
  fechaInicio: yup.string().when('mesCompleto', {
    is: false,
    then: yup.string().typeError('Fecha Inicio es requerido').required('Fecha Inicio es requerido'),
    otherwise: yup.string().nullable().notRequired(),
  }),
  fechaFin: yup.string().when('mesCompleto', {
    is: false,
    then: yup.string().typeError('Fecha Fin es requerido').required('Fecha Fin es requerido'),
    otherwise: yup.string().nullable().notRequired(),
  }),
})
